// extracted by mini-css-extract-plugin
export var messageSideLeft = "_oy-1";
export var messageSideRight = "_oy-2";
export var subscribeToBackInStockBubbleContainer = "_oy-0";